<c-card *transloco="let t">
  <c-card-body *ngIf="group" class="px-2">

      <c-row>
        <c-col class="col-12 col-lg-6">
          <h1>{{ t('Edit Group') }} - {{group.name}}</h1>
        </c-col>
        <c-col class="col-12 col-lg-6 text-end mb-2">
          <c-row class="justify-content-end">
            <c-col xs="auto">

              <div class="btn-group mb-2 " role="group">
                <button color="light" cButton  routerLink="/mgmt/groups/groups">
                  <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                  {{ t('Return to Groups') }}
                </button>
                <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/articles/35907728972817-Instructions-for-Creating-Worker-Groups" role="button" target="_new"><i class="fa-regular fa-circle-question"></i> {{ t('Help') }}</a>
                <button cButton class="my-2" color="danger" class="text-white" (click)="doDelete()" *ngIf="this.okService.hasMonitorAccess('groups','delete')">
                  <i class="fa-solid fa-x"></i> {{ t('Delete') }}
                </button>
            </div>



            </c-col>
          </c-row>
        </c-col>
      </c-row>

      <c-row>
        <c-col class="col-12 col-lg-6">

          <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">


                <div class="form-group row mb-2">
                  <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Name') }}</label>
                  <div class="col-6">
                    <input
                      [formControlName]="'name'"
                      cFormControl
                      placeholder="{{ t('Name') }}"
                      [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                    />
                    <button type="button" class="btn btn-link btn-sm popover-info" id="popover1" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('A suitable name for this group')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                    <div *ngIf="submitted && f['name'].errors && f['name'].errors['invalid']" class="invalid-feedback">
                      {{ f['name'].errors['invalid'] }}
                    </div>
                    <div *ngIf="submitted && f['name'].errors && f['name'].errors['required']" class="invalid-feedback">
                      {{ t('A valid name is required') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilAlarm"></svg> {{ t('Check In Frequency') }}</label>
                  <div class="col-8">
                    <ng-select
                      [items]="check_in_times"
                      bindLabel="name"
                      bindValue="value"
                      formControlName="check_in_freq"
                      placeholder=""
                    >
                    </ng-select>
                    <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('How often the user must check in to let the monitor know they are ok.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                  </div>
                </div>

                <div class="form-group row mb-2" >

                  <label class="col-4 col-form-label text-start text-sm-end">
                    <svg cIcon name="cil-shield-alt"></svg> {{ t('Monitors') }}
                  </label>
                  <div class="col-8">

                    <ng-select [items]="okService.monitors"
                              bindLabel="name"
                              bindValue="id"
                              [multiple]="true"
                              formControlName="monitors"
                              placeholder=""
                              [ngClass]="{ 'border-danger': submitted && f['monitors'].errors }">
                    </ng-select>
                    <div *ngIf="submitted && f['monitors'].errors" class="invalid-feedback">
                      <br/>
                      {{ t('You have reached the limit of monitors that can be assigned to a group. If you require more monitors then please use our Alert Loops feature.') }}
                    </div>
                    <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Choose monitors from the list, they will get alerts for missed check ins and help alerts')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                  </div>
                </div>

              <ng-container *ngIf="okService.alert_loops && (okService.alert_loops).length > 0">

                <div class="form-group row mb-2">

                    <label class="col-4 col-form-label text-start text-sm-end">
                      <svg cIcon name="cilReload"></svg> {{ t('Alert Loop') }}
                    </label>
                    <div class="col-8">
                      <ng-select [items]="alert_loops"
                      bindLabel="name"
                      bindValue="id"
                      [multiple]="false"
                      formControlName="alert_loop"
                      placeholder="">
                      </ng-select>
                      <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('You may choose an alert loop for this group. If there is an alert loop all the workers in the group will then use that alert loop instead of the group monitors')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                    </div>

                </div>

                <ng-container *ngIf="group.alert_loop">
                  <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('alert_loop_notice_'+group.id)">
                    <b>{{ t('Alert Loop Active') }}</b> {{ t("You have chosen an alert loop to receive alerts instead of this group's monitors") }}
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('alert_loop_notice')"></button>
                  </div>
                </ng-container>

              </ng-container>

              <ng-container *ngIf="okService.hasFeature('auto_end_shift')">
              <div class="row mb-3">
                <label class="col-4 col-form-label text-end">{{ t('Auto End Shift Time') }}</label>
                <div class="col-8">
                  <ng-select
                  [items]="day_hours"
                  bindLabel="name"
                  bindValue="value"
                  formControlName="auto_end_shift"
                  placeholder=""
                  >
                  </ng-select>
                  <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Automatically end all worker shifts at a certain time. This affects all workers and should only be used if worker safety is already accounted for at the end of every shift.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                </div>
              </div>
            </ng-container>

              <ng-container *ngIf="okService.settings.international">

                <!-- <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilLocationPin"></svg> {{ t('country') }}</label>
                  <div class="col-8">
                    <ng-select [items]="countryListArray"
                    bindLabel="name"
                    bindValue="code"
                    formControlName="country"
                    placeholder="{{ t('country') }}">
                  </ng-select>
                  </div>
                </div> -->

                <div class="form-group row mb-2" >
                  <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-globe"></i> {{ t('Timezone') }}</label>
                  <div class="col-8">
                    <ng-select [items]="timezoneListArray"
                              bindLabel="label"
                              bindValue="tzCode"
                              formControlName="timezone"
                              placeholder="">
                    </ng-select>
                    <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The timezone of the group, required if they are in another timezone to the account timezone')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                  </div>
                </div>

              </ng-container>

                  <div class="form-group row mb-2" >
                    <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Color') }}</label>
                    <div class="col-8">
                      <input cFormControl [(colorPicker)]="color" [style.background]="color" [cpOKButton]="true" [cpDisableInput]="true" (colorPickerChange)="onColorChange($event)"  [cpAlphaChannel]="'disabled'"
                      [cpOKButtonClass]= "'btn btn-outline-primary btn-sm'" style="max-width:50px"/>
                      <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Choose a colour for this group. Workers in this group will have a coloured location pin on the Locations map that matches the group colour')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                    </div>
                  </div>

            <div class="col-12 mb-2" *ngIf="okService.hasFeature('email_reminder') || okService.hasFeature('checkin_reminders')">

              <div class="card" style="width: auto;">
                <div class="card-header" (click)="view_comms=!view_comms">
                  <i class="fa-solid fa-angles-down float-end"></i>
                  {{ t('Call, SMS, and Email Reminders for Check Ins') }}
                </div>
                <div class="card-body" [hidden]="!view_comms">

                  <ng-container *ngIf="okService.billing.plan.comms_active">


                    <ng-container *ngIf="okService.hasFeature('checkin_reminders')">


                    <div class="form-group row mb-2" >
                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Call Reminder Delay') }}</label>
                      <div class="col-8">
                        <ng-select
                          [items]="alert_times"
                          bindLabel="name"
                          bindValue="value"
                          formControlName="call_alert"
                          placeholder=""
                          [readonly]="!okService.billing.plan.comms_active"
                          (change)="hideCallReminders()"
                        >
                        </ng-select>
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Send a phone call alert to the cell phone after the check in is missed. Please select how many minutes after the missed check in you would like the alert.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                      </div>
                    </div>
                    <div class="form-group row mb-2" *ngIf="call_reminders">
                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Call Reminder Count') }}</label>
                      <div class="col-8">
                        <ng-select
                          class="custom"
                          [items]="alert_repeat"
                          bindLabel="name"
                          bindValue="value"
                          formControlName="call_alert_repeat"
                          placeholder=""
                          [readonly]="!okService.billing.plan.comms_active"
                          (change)="totalRepeats()"
                        >
                        </ng-select>
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('How many times should the call reminder be sent out if they do not check in.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                      </div>
                    </div>


                    <div class="form-group row mb-2" >
                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilMobile"></svg> {{ t('SMS Reminder Delay') }}</label>
                      <div class="col-8">
                        <ng-select
                          [items]="alert_times"
                          bindLabel="name"
                          bindValue="value"
                          formControlName="sms_alert"
                          placeholder=""
                          [readonly]="!okService.billing.plan.comms_active"
                          (change)="hideSMSReminders()"
                        >
                        </ng-select>
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Send an SMS reminder to the cell phone after the checkin is missed. Please select how many minutes after the missed checkin you would like the reminder.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                      </div>
                    </div>

                    <div class="form-group row mb-2" *ngIf="sms_reminders">
                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilMobile"></svg> {{ t('SMS Reminder Count') }}</label>
                      <div class="col-8">
                        <ng-select
                          [items]="alert_repeat"
                          bindLabel="name"
                          bindValue="value"
                          formControlName="sms_alert_repeat"
                          placeholder=""
                          [readonly]="!okService.billing.plan.comms_active"
                          (change)="totalRepeats()"
                        >
                        </ng-select>
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('How many times should the SMS reminder be sent out if they do not check in.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                      </div>
                    </div>


                  </ng-container>

                    <div class="form-group row mb-2"  *ngIf="okService.hasFeature('email_reminder')">
                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilEnvelopeClosed"></svg> {{ t('Email Reminder Delay') }}</label>
                      <div class="col-8">

                        <ng-select
                          [items]="alert_times"
                          bindLabel="name"
                          bindValue="value"
                          formControlName="email_alert"
                          placeholder=""
                          [readonly]="!okService.billing.plan.comms_active"
                        >
                        </ng-select>

                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" [attr.data-bs-content]="t('Send an Email Reminder to the Worker when they miss a check in. An Email will only be sent one time, after the set number of minutes, when they first miss their check in.')">
                          <i class="fa-solid fa-circle-info text-secondary" ></i>
                        </button>
                      </div>
                    </div>

                    @if(okService.settings.arc_on) {
                      <p class="alert alert-warning"><i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('Worker reminders cannot be changed as this account is using our Safety Monitoring Center.') }}</p>
                    }

                    
                  <div class="row m-2 alert alert-danger" *ngIf="tooManyRepeats">
                    <div class="col">
                      <span>{{ t('Please only choose a maximum of 4 combined SMS and Call Check-In Reminder Repeats') }}</span>
                    </div>
                  </div>

                  </ng-container>

                    <ng-container *ngIf="!okService.billing.plan.comms_active">
                      <div class="alert alert-warning" role="alert">
                        <i class="fa-solid fa-triangle-exclamation text-danger"></i> 
                        @if(okService.billing.plan.account_type == "Pricing2024"){
                          {{ t('To use check in reminders you must have the Automated Plan for your account. To set up an automated plan please go to your') }} 
                        }@else{   
                        {{ t('To use check in reminders you must have the Comms Plan for your account. To set up a comms plan please go to your') }} 
                        }                       
                        <a routerLink="/account/account">{{ t('Account Settings') }}</a>.<br/>
                        <i class="fa-solid fa-circle-info text-info"></i> {{ t('Learn more about check in reminders') }} <a href="https://okalone.zendesk.com/hc/en-gb/articles/35353033606289-Setting-Up-Worker-Reminders" target="_new">{{ t('here') }}</a>.
                      </div>
                    </ng-container>
                  </div>

                </div>
              </div>

              <div class="col-12 mb-2" *ngIf="group.outhrs_on">
                <div class="card" style="width: auto;">
                  <div class="card-header" (click)="view_outhrs=!view_outhrs">
                    <i class="fa-solid fa-angles-down float-end"></i>
                    <span *ngIf="group.outhrs_available && ((group.outhrs_monitors && group.outhrs_monitors.length>0) || group.outhrs_alertloop)">
                      <i class="fa-solid fa-circle-check text-success"></i>
                    </span>
                    {{ t('Group Out of Hours Settings')}}
                  </div>
                  <div class="card-body" [hidden]="!view_outhrs">

                    <div class="alert alert-info" role="alert">{{ t('Out of Hours monitoring is used outside of regular business hours. Monitors or an Alert Loop chosen here will be contacted only if an alert comes in outside of the chosen Out of Hours times. Alert Loops allow for an automated, timed sequence of monitors to be contacted until an alert is accepted. Set your out of hours') }}
                    <a a routerLink="/mgmt/outofhours"> {{ t('here') }}</a>.</div>

                    <div class="alert alert-warning" role="alert" *ngIf="!group.outhrs_available">
                      <i class="fa-solid fa-triangle-exclamation"></i> {{ t('To use out of hours monitoring please setup your business hours ') }}<a a routerLink="/mgmt/outofhours">{{ t('here') }}</a>
                    </div>

                    <div class="form-group row mb-2 mt-2" >
                      <label class="col-sm-4 col-form-label text-end"><svg cIcon name="cil-shield-alt"></svg> {{ t('Monitors') }}&nbsp;</label>
                      <div class="col-sm-6">

                        <ng-select [items]="okService.monitors"
                                  bindLabel="name"
                                  bindValue="id"
                                  [multiple]="true"
                                  formControlName="outhrs_monitors"
                                  [ngClass]="{ 'border-danger': submitted && f['outhrs_monitors'].errors }">
                        </ng-select>
                        <div *ngIf="submitted && f['outhrs_monitors'].errors" class="invalid-feedback">
                          <br/>
                          {{ t('A maximum of 4 monitors can be assigned to a group. If you require more monitors then please use our Alert Loops feature.') }}
                        </div>
                      </div>
                      <div class="col-sm-2 text-start">
                        <span class="badge bg-success fs-4" *ngIf="group.outhrs_monitors && group.outhrs_monitors.length>0 && !group.outhrs_alertloop"><i class="fa-solid fa-circle-check"></i></span>
                      </div>
                    </div>

                    <div class="form-group row mb-2" *ngIf="okService.alert_loops.length > 0">
                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilReload"></svg> {{ t('Alert Loop') }}</label>
                      <div class="col-sm-6">
                        <ng-select [items]="okService.alert_loops"
                        bindLabel="name"
                        bindValue="id"
                        [multiple]="false"
                        formControlName="outhrs_alertloop"
                        placeholder="">
                      </ng-select>
                      </div>
                      <div class="col-sm-2 text-start">
                        <span class="badge bg-success fs-4" *ngIf="group.outhrs_alertloop"><i class="fa-solid fa-circle-check"></i></span>
                      </div>
                    </div>

                    <div class="alert alert-success" role="alert" *ngIf="group.outhrs_monitors && group.outhrs_monitors.length>0 && !group.outhrs_alertloop">
                      {{ t('You have chosen monitors to be alerted out of hours.') }}
                    </div>

                    <div class="alert alert-success" role="alert" *ngIf="group.outhrs_alertloop">
                      {{ t('You have chosen an alert loop to be used for alerts out of hours.') }}
                    </div>


                  </div>
                </div>
              </div>

              <div class="text-center">

                <div class="row">
                  <div class="col-12">
                    <input class="form-check-input" type="checkbox" id="sync" name="sync"  formControlName="sync">
                    <label class="form-check-label" for="sync">
                      &nbsp; {{ t('Update all Workers with these Settings') }}
                    </label>
                  </div>
                </div>

                <button cButton class="text-white btn-info mt-2" type="submit" *ngIf="this.okService.hasMonitorAccess('groups','update')" [disabled]="tooManyRepeats">
                    <i class="fa-solid fa-check"></i> {{ t('Update the Group') }}
                </button>
              </div>



          </form>
        </c-col>
        <c-col class="col-12 col-lg-6 mb-2">

          @if(this.okService.hasMonitorAccess('groups','update')){

          <div class="row text-center">
            <div class="col">
              <button type="button" class="btn btn-outline-info m-2" (click)="sendLinks()" [disabled]="send_loading">
                <span [hidden]="send_loading">
                  <i class="fa-solid fa-paper-plane"></i>
                </span>
                <span [hidden]="!send_loading">
                  <i class="fa-solid fa-spinner fa-spin"></i>
                </span>
                {{ t('Send App Links to Workers') }}
              </button>
            </div>

            <div class="col">
              <button type="button" class="btn btn-outline-info m-2" (click)="sendMonitorEmails()" [disabled]="send_monitor_loading" *ngIf="group.monitors.length > 0">
                <span [hidden]="send_monitor_loading">
                  <i class="fa-solid fa-paper-plane"></i>
                </span>
                <span [hidden]="!send_monitor_loading">
                  <i class="fa-solid fa-spinner fa-spin"></i>
                </span>
                {{ t('Send Welcome Emails to Monitors') }}
              </button>
            </div>
          </div>

          @if(okService.hasFeature('escalation_procedure')){  

          <ng-container *ngIf="group.escalation_procedure">


            <div class="card mt-2">
              <div class="card-header" (click)="view_escalation=!view_escalation">
                <button color="light" cButton class="m-1 float-end" routerLink="/mgmt/group-escalation/{{id}}">
                  <i class="fa-solid fa-pencil"></i>
                  {{ t('Edit') }}
                </button>
                <h5><i class="fa-solid fa-angles-down"></i> {{ t('Your Group Escalation Procedure') }}</h5>
              </div>
              <div class="card-body" [innerHtml]="group.escalation_procedure" *ngIf="view_escalation">

              </div>
            </div>

          </ng-container>




          <ng-container *ngIf="!group.escalation_procedure">
            <div class="text-center">
              <button color="light" cButton class="m-1" routerLink="/mgmt/group-escalation/{{id}}">
                <i class="fa-solid fa-pencil"></i>
                {{ t('Add Group Escalation') }}
              </button>
            </div>
          </ng-container>


          }



      <div class="card mt-3">
        <div class="card-header">
          <h3>{{ t('Add Workers to the Group') }}</h3>
        </div>
        <div class="card-body">
          <p>{{ t('To add workers to this group please choose them here:') }}</p>
            <form  [formGroup]="workerFormGroup" (ngSubmit)=" doAddWorker()" class="row">

          <div class="col-auto">
            <div class="form-group row mb-2" >
              <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon  name="cilPeople"></svg> {{ t('Workers') }}</label>
              <div class="col-8">
                <ng-select [items]="okService.workers"
                  bindLabel="name"
                  bindValue="id"
                  [multiple]="true"
                  formControlName="ids">
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-auto">
              <button type="button" class="btn btn-outline-primary" type="submit">
              <i class="fa-solid fa-check"></i> {{ t('Add the Workers') }}
            </button>
          </div>



          </form>
        </div>
      </div>


    }

        </c-col>
      </c-row>

      <hr />

      <div class="card mt-3">
        <div class="card-header">
          <c-row>
            <c-col xs="6">
          <h3>{{ t('The Workers in this Group') }}</h3>
          </c-col>
            <c-col xs="6" class="text-end">
              <button type="button" class="btn btn-success btn-sm text-white"type="submit" (click)="syncWorkers()" *ngIf="this.okService.hasMonitorAccess('groups','update')"><i class="fa-solid fa-refresh"></i> {{ t('Synchronise all Workers') }}</button>
            </c-col>
          </c-row>
        </div>
        <div class="card-body">


          <table
          [hover]="true"
          [responsive]="true"
          [striped]="true"
          align="middle"
          cTable
          class="mb-0 border"
          >
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">{{ t('Name') }}</th>
                <th scope="col">{{ t('Monitors') }}</th>
                <th scope="col">{{ t('Check In') }}</th>
                <th scope="col">{{ t('SMS Reminder') }}</th>
                <th scope="col">{{ t('Call Reminder') }}</th>
                <th scope="col">{{ t('Email Reminder') }}</th>
                <th scope="col" *ngIf="this.okService.alert_loops && this.okService.alert_loops.length > 0">{{ t('Alert Loops') }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let worker of group.workers">
                <td>
                  @if(this.okService.hasMonitorAccess('groups','update')){
                  <button type="button" class="btn btn-info btn-sm text-white mb-1" routerLink="/mgmt/worker/{{worker.id}}"><i class="fa-solid fa-eye"></i> {{ t('View') }}</button>
                  <button type="button" class="btn btn-warning btn-sm text-white mb-1 mx-1" type="submit" (click)="doRemoveWorker(worker)"><i class="fa-solid fa-circle-xmark"></i> {{ t('Remove') }}</button>
                  <button type="button" class="btn btn-success btn-sm text-white mb-1" type="submit" (click)="syncWorker(worker)" *ngIf="group.sync[worker.id].required"><i class="fa-solid fa-refresh"></i> {{ t('Sync') }}</button>
                  }
                </td>
                <td>
                  <b>{{worker.name}}</b>
                </td>
                <td [class.text-danger]="group.sync[worker.id].monitors">{{worker.monitor_names}}</td>
                <td [class.text-danger]="group.sync[worker.id].check_in_freq">{{u.minsToString(worker.check_in_freq)}}</td>
                <td [class.text-danger]="group.sync[worker.id].sms_alert">{{_.find(alert_times,{value:worker.sms_alert}).name}}</td>
                <td [class.text-danger]="group.sync[worker.id].call_alert">{{_.find(alert_times,{value:worker.call_alert}).name}}</td>
                <td [class.text-danger]="group.sync[worker.id].email_alert">{{_.find(alert_times,{value:worker.email_alert}).name}}</td>
                <th *ngIf="this.okService.alert_loops.length > 0" [class.text-danger]="group.sync[worker.id].alert_loop">
                    {{worker.alert_loop_name}}
                </th>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
  </c-card-body>
</c-card>
